// export const server = `https://mpstaging.iauto.sg/api/cms/`; // staging
// export const tnc = `https://mpstaging.iauto.sg/terms-and-conditions/`; // staging
// export const pnP = `https://mpstaging.iauto.sg/privacy-policy/`; // staging
// export const backToHome = `https://mpstaging.iauto.sg/`; // staging

export const server = `https://manage.iauto.sg/api/cms/`; // production
export const tnc = `https://www.iauto.sg/terms-and-conditions/`; // production
export const pnP = `https://www.iauto.sg/privacy-policy/`; // production
export const backToHome = `https://www.iauto.sg/`; // production
// 
export const requestAuthOption = (formData) => {
    let token = JSON.parse(localStorage.getItem("token"))

    if (formData) {
        const requestOptions = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`, // ✅ keep the token
                // ❌ don't set 'Content-Type' here
            },
            body: formData,
        };
        return requestOptions
    }
}
